import {organizeFileStatuses} from "./uploads";
import {userHasSchool} from "./users";

export function organizeBatchReports(userComposite, reports, schoolStatuses) {
  const organizedBatchReports = {};

  const schoolsToShow = getBatchReportSchools(userComposite, reports, schoolStatuses);

  reports.forEach((report, index) => {
    if (showSchoolBatchReports(schoolsToShow, report.schooPdf.schoolId)) {
      const schoolName = report.schoolName;
      const schoolPdf = report.schooPdf;

      if (!organizedBatchReports[schoolName]) {
        organizedBatchReports[schoolName] = {
          schoolName: schoolName,
          gradeLevels: {}
        };
      }

      if (!organizedBatchReports[schoolName]['gradeLevels'][schoolPdf.gradeLevel]) {
        organizedBatchReports[schoolName]['gradeLevels'][schoolPdf.gradeLevel] = {
          gradeLevel: schoolPdf.gradeLevel,
          reports: [
            schoolPdf
          ]
        }
      } else {
        organizedBatchReports[schoolName]['gradeLevels'][schoolPdf.gradeLevel]['reports'].push(schoolPdf);
      }
    }
  });

  return organizedBatchReports;
}

export function getBatchReportSchools(userComposite, reports, schoolStatuses) {
  const schoolsToShow = [];

  schoolStatuses.forEach((schoolStatus) => {
    if (userHasSchool(userComposite, schoolStatus.school.id) && schoolStatus.school.accessDataStatus === 'Final') {
      schoolsToShow.push(schoolStatus.school.id);
    }
  });

  return schoolsToShow;
}

export function showSchoolBatchReports(schoolsToShow, schoolId) {
  return (schoolsToShow.find(school => school === schoolId));
}

export function checkSchoolReportsCount(schoolStatuses, reportType) {
  const organizedFileStatuses = organizeFileStatuses(schoolStatuses);
  let schoolCount = 0;

  organizedFileStatuses[reportType].forEach((schoolStatus) => {
    if (schoolStatus.files.length > 0) {
      schoolCount++;
    }
  })


  const totalCount = (schoolStatuses) ? schoolStatuses.length : 0;

  return [
    schoolCount,
    totalCount,
  ];
}